<script setup lang="ts">
import Profile from "@/views/playground/planner/business-management/service-management/information/Profile.vue";
</script>

<template>
  <profile></profile>
</template>

<style scoped></style>
